<fin-corporate-hero
  [title]="'CORPORATE.corporatePortal.users.title' | finLocalization"
  [description]="description$ | async | finLocalization"
></fin-corporate-hero>

<div class="grid-col-12 grid-max-width">
  <div class="col-1-12 ps-large-y">
    <ng-container *ngIf="!loading">
      <fin-user-list *ngIf="!selectedUserId" (userSelected)="selectedUserId = $event"></fin-user-list>

      <fin-user-details
        *ngIf="selectedUserId"
        [userId$]="selectedUserId | finToObservable"
        (navigatedBack)="deselectUser()"
      ></fin-user-details>
    </ng-container>
  </div>
</div>
